module.exports = __webpack_public_path__ + "img/AirportShuttleOutlined.e01f8d99.svg";